import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { businessSubject } from 'src/app/guard/business-details-guard.ts.service';
import { ApiService } from 'src/app/services/api.service';
import { LangdingPageNavBarComponent } from '../../../components/langding-page-nav-bar/langding-page-nav-bar.component';

@Component({
  selector: 'app-user-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, LangdingPageNavBarComponent],
  templateUrl: './user-layout.component.html',
  styleUrls: ['./user-layout.component.scss']
})
export class UserLayoutComponent implements OnInit , OnDestroy {
  businessSubscription: Subscription;
  routerSubscription: Subscription;
  isFullWidth = false;
  constructor(private router: Router , private API : ApiService, private activatedRoute: ActivatedRoute) {
    this.routerSubscription = this.router.events.subscribe(() => {
    this.currentPath = this.router.url.substring(0, 26);
    if(this.currentPath=='/userClassification?userId'){
     this.show=false;
    }else{
      this.show=true;
    }

  });

  this.businessSubscription = businessSubject.subscribe((resolveData:any) =>{

    if(resolveData){
      localStorage.setItem('businessId' , resolveData.businessId);
      console.log("user layout business data", resolveData);
    }

  });
 }

  ngOnDestroy(): void {
    if(this.businessSubscription){
      this.businessSubscription.unsubscribe();
    }
    if(this.routerSubscription){
      this.routerSubscription.unsubscribe();
    }
    businessSubject.next(null);

   }

  currentPath: string;
  show=false;
  ngOnInit() {
    // Initialize on first paint so direct loads (e.g. F5 on /newjobs) get the
    // correct container class without waiting for a NavigationEnd event.
    this.updateFullWidthFromRoute();
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {
        this.updateFullWidthFromRoute();
        // Every authenticated page (landingPage/*, networkPage/*, teamPage/*,
        // business/*, ...) renders inside this single root layout's
        // <router-outlet>, so switching a side menu (e.g. Recruiter Network's
        // Home/About/Members) swaps the child view in place without a full
        // page reload. There's no global `scrollPositionRestoration`
        // configured on the router, so the browser keeps whatever Y offset
        // the previous view was scrolled to unless we reset it here.
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

  private updateFullWidthFromRoute(): void {
    // Walk from this layout's route down to the deepest activated child,
    // checking every level for `fullWidth: true`. Walking the whole chain
    // (rather than only the leaf) lets us tag a parent route once and have
    // every lazy-loaded child inherit it, without depending on Angular's
    // snapshot data inheritance rules.
    let route: ActivatedRoute | null = this.activatedRoute;
    let isFullWidth = false;
    while (route) {
      if (route.snapshot.data?.['fullWidth'] === true) {
        isFullWidth = true;
        break;
      }
      route = route.firstChild;
    }
    this.isFullWidth = isFullWidth;
  }




}
